import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, Alert } from '../../../js/ComponentManager'

/* 개발담당: 양유빈
 * 화면기능: 채팅화면
 * 세부설명:
*/

export class ConverInfo extends Component {
    static displayName = ConverInfo.name;

    constructor(props) {
        super(props);
        this.state = {
            MasterData: [],
            ConverSationList: [],
            CommentList:[],
            Content:""
        };
        this.CsName = Big3Common.ContentState;
        this.Uid = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Uid, null);
        this.QstgrpNo = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.QstgrpNo, null);
        this.OrdgrpNo = 0;
        this.handelComment_Save = this.handelComment_Save.bind(this);
        this.handle_Blur = this.handle_Blur.bind(this);
        this.handlePaper_Click = this.handlePaper_Click.bind(this);
        this.Comment = "";
        this.isSubmit = true; //코멘트 전송 가능여부(true면 전송, false면 전송불가)
    }
    //초기화
    async componentDidMount() {
        await this.CallQstMgtDtlListData();
    }
    componentDidUpdate() {
        const ContainerBox = document.getElementsByClassName("container_box")[0];
        const scrollY = ContainerBox.clientHeight;
        window.scrollTo({ top: scrollY, left: 0, behavior: "instant" });
    }
    //주문문의 조회(마스터+상태+코멘트 내역)
    async CallQstMgtDtlListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Model = {
                qstgrp_no:this.QstgrpNo,
                uid: this.Uid
            }
            let Data = await Big3Common.Post('api/Chat/ChatList/GetQstMgtConverSation', Model);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CallList = JSON.parse(Data.multiDataTable);
                if (CallList.Master.length > 0) {
                    this.OrdgrpNo = CallList.Master[0].ordgrp_no;
                }
                this.setState({
                    MasterData: CallList.Master,
                    ConverSationList: CallList.ConverSationList,
                    CommentList: CallList.CommentList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtDtlListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
     //코멘트만 조회
    async CallQstmgtCommentListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Model = {
                qstgrp_no: this.QstgrpNo,
                uid: this.Uid
            }
            let Data = await Big3Common.Post('api/Chat/ChatList/GetQstmgtCommentList', Model);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CommentList = JSON.parse(Data.dataTable);
                this.setState({ 
                    CommentList: CommentList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstmgtCommentListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    
    handle_Blur(event) {
        this.Comment = event.target.value;
    }
    //주문서 이동
    handlePaper_Click(event, list) {

        let CompName = "OrderComplete";
        if (list.qst_status === "QA" || list.qst_status === "AN") {
            //재고문의, 재고답변
            CompName = "Inventory";
        }
        
        const whole_name = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Whole_Name, "");
        //마지막 상태값
        const LastStatus = this.state.ConverSationList[this.state.ConverSationList.length - 1];
        this.props.RenderComponent(CompName,
            {
                [this.CsName.Uid]: this.Uid,
                [this.CsName.QstgrpNo]: this.QstgrpNo,
                [this.CsName.QstStatus]: list.qst_status,
                [this.CsName.Whole_Name]: whole_name,
                [this.CsName.Ordgrp_No]: this.OrdgrpNo,
                LastStatus: LastStatus.length === 0 ? list.qst_status : LastStatus.qst_status
            });
        event.preventDefault();
    }
    //코멘트 등록
    async handelComment_Save(event) {
        try {
            if (this.Comment === "") {
                this.setState({ Content: "문의내용을 입력하세요." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            if (!this.isSubmit) {
                return false;
            }
            this.isSubmit = false;
            let Data = await Big3Common.Post('api/Chat/ChatList/RegisterComment',
                {
                    Contt: this.Comment,
                    Uid: this.Uid,
                    Qstgrp_no: this.QstgrpNo
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.Comment = "";
                document.getElementById("Comment").value = "";
                this.CallQstmgtCommentListData();
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handelComment_Save: ", e);
        }
        finally {
            this.isSubmit = true;
        }
        event.preventDefault();
    }
    //기본정보
    Masterrender() {
        if (this.state.MasterData.length === 0) return false;
        const MasterData = this.state.MasterData[0];        
        return (
            <div className="alert_content no_title alert_content">
                <div className="alert_img">
                    <GoodsPhoto className="alert_img_in"
                        ImageSrc={MasterData.img_220}
                    />
                </div>
                <div className="alert_txt">
                    <div className="shop_name">문의번호 : {this.QstgrpNo} </div>
                    <div className="shop_name">{MasterData.reg_dt}</div>
                    <div className="alert_detail_v2">{MasterData.goods_names}</div>
                    <div className="alert_detail_v2">금액: {MasterData.strqst_yn === "Y" ? "매장문의" :`${Big3Common.Util.Money(MasterData.goods_price)}원`}</div>
                   {/* <div className="order_btn or_btn4">상세보기</div>*/}
                    <div className="status">{MasterData.qstmgt_status_nm}</div>
                </div>
            </div>
        )
    }
    //상태에때른 대화 내역
    Statusrender() {

        if (this.state.ConverSationList.length === 0) return false;
        const ConverSationList = this.state.ConverSationList;
        //QA:재고문의, AN:재고답변, JM:상품주문, PJ:포장완료, GR:거래완료, CS:거래취소
       
        return (
            <div className="default_request_box">
                {
                    ConverSationList.map((list, idx) =>
                        <div className={idx % 2 === 0 ? "default_request_left_box pointer" : "default_request_right_box pointer"}
                            key={list.qst_status}
                            onClick={(e) => { this.handlePaper_Click(e,list) } }
                        >
                            <div className="txt">{list.qst_status_nm}</div>
                            <div className="arrow"></div>
                        </div>
                    )
                }
            </div>
        )
    }
    Commentrender() {
        if (this.state.CommentList.length === 0) {
            return false;
        }
        const CommentMap = Big3Common.Util.groupBy(this.state.CommentList, list => list.dayname);
        let CommentList = [];
        for (const item of CommentMap.entries()) {
            CommentList.push({ "DateName": item[0], "DtlList": item[1] });
        }
        function ChatMessageBox(subList) {
            if (subList.user_idx === 'RE') {
                return (
                    <>
                        <div className="Conversation">{subList.contt}</div>
                        <div className="chat_time">{subList.sendtime}</div>
                    </>
                )
            }
            else {
                return (
                    <>
                        <div className="chat_time">{subList.sendtime}</div>
                        <div className="Conversation">{subList.contt}</div>
                    </>
                )
            }
        }
        return (
            <div className="chating_box">
                <div className="select_box">
                    <div className="category_box reset" onClick={(e) => { this.CallQstmgtCommentListData(); e.preventDefault(); }}>
                        <div className="category">새로고침</div>
                        <div className="reset_btn"></div>
                    </div>
                </div>
                {
                    CommentList.map((list, idx) =>
                        <div key={idx }>
                            <div className="chat_date">{list.DateName}</div>
                            {
                                list.DtlList.map((subList, subidx) =>
                                    <div key={subidx} className={subList.user_idx === 'RE' ? "chatbox_right" : "chatbox_left"} >
                                        <div className="Conversation_box">
                                            {ChatMessageBox(subList)}
                                            {
                                                subList.user_idx ==='RE' && subList.views===1 ? <div className="chat_check">{subList.views}</div> : ""
                                                //소매가 작성한 코멘트를 도매가 읽었는지 체크
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            </div>
        )
    }
    render() {
        const Masterrender = this.Masterrender();
        const Statusrender = this.Statusrender();
        const Commentrender = this.Commentrender();
        return (
            <div>
                <div className="p_margin d_padding container_box">
                    {Masterrender}
                    {Statusrender }
                    {Commentrender }
                    <div className="chat_input_box">
                        <div className="chat_input">
                            <input type="text" className="form-control" maxLength="100" id="Comment"
                                onBlur={(e) => { this.handle_Blur(e) } }
                                placeholder="문의하실 내용을 입력해주세요." />
                        </div>
                        <div className="send_btn pointer"
                            onClick={(e) => { this.handelComment_Save(e) }}></div>
                    </div>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="주문문의안내"
                />
            </div>
        );
    }
}
